import Button from '@atoms/new/button';
import ImageLoader from '@atoms/new/imageLoader';
import SettingBlock from '@components/Presentation/main/Settings/units/SettingBlock';
import uploadFileToS3 from '@components/RunOfShow/helper/uploadToS3';
import ErrorBanner from '@components/themes/ThemeModal/EditTheme/MenuSettings/units/ErrorBanner';
import FileUploader from '@molecules/FileUploader';

import React, { useState } from 'react';
import { XIcon as CloseRoundedIcon } from '@phosphor-icons/react';

function QuizImageUploader({ setting, updateSetting }) {
  const slideImage = setting.quizSlideImageSrc;
  const [isLoading, setIsLoading] = useState(false);
  const [customErrMessage, setCustomErrMessage] = useState('');

  const uploadFileToS3andSave = async (fileToUpload) => {
    setIsLoading(true);
    try {
      const { name } = fileToUpload[0];
      const extension = name.split('.').slice(-1)[0];
      const fileNameWithoutExtension = name.replace(`.${extension}`, '').replace(/\s+/g, '_');
      const fileKey = `Theme-Images/${fileNameWithoutExtension}_${Date.now()}.${extension}`;

      await uploadFileToS3(fileToUpload[0], fileKey, () => { });

      updateSetting('quizSlideImageSrc', fileKey);
    } catch (error) {
    }
    setIsLoading(false);
  };
  return (
    <SettingBlock
      title="Image"
      hasBorderTop={true}
      tooltip={
        <p>
          Upload an image for the quiz.
        </p>
      }
      addPadding={false}
    >
      {!slideImage && <FileUploader
        accept={{
          'image/png': ['.png'],
          'image/jpeg': ['.jpg', '.jpeg'],
          'image/webp': ['.webp'],
          // @ts-expect-error js component
          'image/gif': ['.gif'],
        }}
        element={
          <Button
            size='sm'
            kind='secondary'
            className='w-full mb-3'
            startContent={
              <ImageLoader src='/images/empty_img.svg' className='size-4' />
            }
          >Upload</Button>
        }
        uploadFileToS3andSave={uploadFileToS3andSave}
        showProgress={false}
        maxSize={10485760}
        maxSizeErrorMsg='Maximum size allowed is 10MB.'
        isUploadInProgress={false}
        setIsUploadInProgress={() => { }}
        updateCustomErrorMessage={(msg) => setCustomErrMessage(msg)}
        showDefaultErrorMessage={false}
      />}
      {!isLoading && !slideImage && <>
        <ErrorBanner errMsg={customErrMessage} />
      </>}
      {
        !isLoading && slideImage && <div className='relative h-8 w-14 flex items-center justify-center mb-3'>
          <button
            onClick={() => updateSetting('quizSlideImageSrc', null)}
            className='z-20 w-6 rounded-full absolute -top-6 translate-y-1/2 right-0 bg-grey-100 dark:bg-grey-800 translate-x-1/2 shadow-md hover:bg-grey-200 hover:dark:bg-grey-700 transition-colors'>
            <CloseRoundedIcon className='dark:text-grey-400' style={{ fontSize: '16px' }} />
          </button>
          {!isLoading && <ImageLoader
            src={`${process.env.NEXT_PUBLIC_BUCKET_URL}${slideImage}`}
            className='size-full object-cover rounded-lg'
            alt='quiz image' />}
        </div>}
    </SettingBlock>
  );
}

export default QuizImageUploader;
